<template>
    <div>
        <button
            class="btn dm-btn-padding dm-btn-brand font-weight-boldest font-weight-boldest"
            data="The Select Blueprint Popup"
            @click="openSelectPreviousSubmissionModal()"
        >
            {{ translate("Submit your project") }}
        </button>

        <modal
            size="md"
            class="text-left dm-modal dm-select-blueprint-modal"
            id="dm-select-blueprint-modal"
        >
            <div class="dm-blueprint-select-container">
                <select
                    class="form-control mb-4"
                    v-model="selected_blueprint_id"
                >
                    <option value="" selected disabled>
                        {{ translate("Select presentation") }}
                    </option>
                    <option
                        v-for="blueprint in blueprints"
                        :value="blueprint.id"
                        :key="'blueprint-' + blueprint.id"
                    >
                        {{ blueprint.title }}
                    </option>
                </select>

                <div>
                    <button
                        class="btn btn-success w-100"
                        :disabled="!selected_blueprint_id"
                        @click="createSubmissionFromBlueprint()"
                    >
                        {{ translate("Use above manuscript") }}
                    </button>

                    <p class="text-center my-4">or</p>

                    <button
                        class="btn btn-success w-100 dm-create-new-manuscript-button"
                        @click="createBrandNewSubmission()"
                    >
                        {{ translate("Create new manuscript") }}
                    </button>
                </div>
            </div>
        </modal>

        <modal
            :title="translate('Please wait a few seconds...')"
            size="lg"
            class="text-left dm-modal dm-creating-from-blueprint-modal"
            id="dm-creating-from-blueprint-modal"
            hide_close_btn="true"
            block_click_away_esc="true"
        >
            <spinner />
        </modal>
    </div>
</template>

<script>
export default {
    data() {
        return {
            blueprints: [],
            company_id: companyId, // Exists in the DOM
            company_name: companyName, // Exists in the DOM
            entry_point_id: entryPointId, // Must exist in DOM
            selected_blueprint_id: "",

            company_slug: companySlug, // Must Exist in DOM
            company_categories_list: [],
        };
    },

    computed: {
        companyCategoryIds() {
            var categoriesIds = [];
            $.each(
                this.company_categories_list,
                function (index, companyCategory) {
                    categoriesIds.push(companyCategory.id);
                },
            );

            return categoriesIds;
        },
    },

    methods: {
        openSelectPreviousSubmissionModal() {
            this.loadBlueprintsNotSubmittedToCurrentCompany();

            jQuery("#dm-select-blueprint-modal").modal();
        },

        showCreatingFromBlueprintModal() {
            this.hideModals();
            jQuery("#dm-creating-from-blueprint-modal").modal();
        },

        loadBlueprintsNotSubmittedToCurrentCompany() {
            var self = this;
            axios
                .get(
                    "/api/author/blueprints/exclude-company/" + this.company_id,
                )
                .then(function (response) {
                    self.blueprints = response.data;
                });
        },

        loadCompanyCategoriesList() {
            var self = this;
            axios
                .get(  "/api/companies/" +  this.company_id + "/taxonomies/categories-list")
                .then(function (response) {
                    self.company_categories_list = response.data;
                });
        },

        createBrandNewSubmission() {
            var self = this;
            axios
                .post("/api/author/submissions/select-submission/create-brand-new-submission", {
                    company_id: this.company_id,
                    entry_point_id: self.entry_point_id,
                } )
                .then(function (response) {
                    let wizardPath = "/" + self.company_slug + "/submit/start";
                    window.location.href = wizardPath;
                });
        },

        createSubmissionFromBlueprint() {
            this.showCreatingFromBlueprintModal();

            var self = this;
            axios
                .post(
                    "/api/author/submissions/select-submission/new-from-blueprint",
                    {
                        company_id: this.company_id,
                        blueprint_id: self.selected_blueprint_id,
                        entry_point_id: self.entry_point_id,
                    },
                )
                .then(function (response) {
                    let wizardPath =
                        "/" + self.company_slug + "/submit/start";
                    window.location.href = wizardPath;
                });
        },
    },

    mounted() {
        this.loadCompanyCategoriesList();

        var self = this;
        if (
            typeof showPreviousSubmissionModal !== "undefined" &&
            showPreviousSubmissionModal === true
        ) {
            setTimeout(function () {
                self.openSelectPreviousSubmissionModal();
            }, 300);
        }
    },
};
</script>
